import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-medium text-primary-color-600 hover:text-primary-color-500" }

import { withDefaults } from "vue"

interface Props {
    to?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsLink',
  props: {
    to: { default: "/" }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: props.to
  }, {
    default: _withCtx(() => [
      _createElementVNode("a", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["to"]))
}
}

})